<form [formGroup]="formGroup">
    <nuc-form-field label="Select Rate limit group">
        <nuc-dropdown formControlName="group" [items]="rateLimitGroups" [nullOption]="false"></nuc-dropdown>
    </nuc-form-field>
    <nuc-form-field label="Requests per second">
        <nuc-input formControlName="rps" type="number" placeholder="Fill in the requests per second limit"></nuc-input>
    </nuc-form-field>
    <nuc-form-field label="Burst Requests per second">
        <nuc-input formControlName="burstRps" type="number" placeholder="Fill in the requests per second limit during burst"></nuc-input>
    </nuc-form-field>
    <nuc-form-field label="Burst duration">
        <nuc-input formControlName="burstDuration" type="number" placeholder="Fill in maximum burst duration in seconds "></nuc-input>
    </nuc-form-field>
</form>
